import { supabase } from '../supabaseClient';

/**
 * Calculates the number of vacation days taken in the current cycle for an employee
 * @param {string} renovationDay - The next renovation day (YYYY-MM-DD)
 * @param {number} employeeId - The employee's ID
 * @returns {Promise<number>} The number of days taken in the current cycle (can include half days)
 */
export const calculateDaysTaken = async (renovationDay, employeeId) => {
    try {
        // Calculate past renovation day (1 year before the next renovation day)
        const nextRenovationDate = new Date(renovationDay);
        const pastRenovationDate = new Date(nextRenovationDate);
        pastRenovationDate.setFullYear(pastRenovationDate.getFullYear() - 1);
        
        // Format the past renovation date to YYYY-MM-DD
        const pastRenovationDay = pastRenovationDate.toISOString().split('T')[0];

        // Query vacation days for the employee since the past renovation day
        // Now including the has_half_day column
        const { data: vacationDays, error } = await supabase
            .from('vacation_days')
            .select('vacation_date, has_half_day')
            .eq('employee_id', employeeId)
            .gte('vacation_date', pastRenovationDay)
            .lt('vacation_date', renovationDay);

        if (error) {
            console.error('Error fetching vacation days:', error);
            throw error;
        }

        // Calculate total days using reduce for better performance
        // Each day counts as 1 if has_half_day is false, 0.5 if true
        const totalDays = vacationDays?.reduce((sum, day) => 
            sum + (day.has_half_day ? 0.5 : 1), 0) || 0;

        return totalDays;
    } catch (error) {
        console.error('Error calculating days taken:', error);
        throw error;
    }
};